import { useTranslation } from 'react-i18next'

import { languages } from '@/lib/i18n'
import { sendLanguageChangedEvent } from '@/services/analytics/gtm'

export default function LanguagePicker() {
  const { i18n } = useTranslation()

  function onClick(l: string) {
    i18n.changeLanguage(l)
    sendLanguageChangedEvent(l)
  }

  return Object.keys(languages).map((l) => (
    <div key={l} className='my-auto '>
      <button
        type='submit'
        className={`${
          i18n.resolvedLanguage === l ? 'font-semibold' : 'font-light'
        } text-sm lg:text-base py-0.5 px-1 border-1 rounded-lg border-transparent hover:cursor-pointer hover:border-cta hover:bg-cta-active/20`}
        onClick={() => onClick(l)}
      >
        {languages[l].nativeName}
      </button>
    </div>
  ))
}
